import React, { useEffect, useState } from 'react'
import { CookieBanner as Banner } from '@tumelo/designsystem'
import { useLocalStorage } from '@/utilities/useLocalStorage'

export enum CookieConsentValue {
  Accepted = 'accepted',
  Rejected = 'rejected',
  NotSet = '',
}

export const cookieConsentKey = 'cookieconsent'

export const CookieBanner: React.FC = () => {
  const [cookieConsent, setCookieConsent] = useLocalStorage(cookieConsentKey, CookieConsentValue.NotSet)
  const [isMounted, setIsMounted] = useState(false)

  // Ensure the component only interacts with local storage after mounting
  useEffect(() => {
    setIsMounted(true)
  }, [])

  const onClickAccept = () => {
    setCookieConsent(CookieConsentValue.Accepted)
  }
  const onClickReject = () => {
    setCookieConsent(CookieConsentValue.Rejected)
  }

  // Avoid rendering the banner until the component is mounted (prevents hydration errors)
  if (!isMounted || cookieConsent !== CookieConsentValue.NotSet) return null

  return <Banner onClickAccept={onClickAccept} onClickReject={onClickReject} />
}
